import {EntityBase} from "../../shared/entity/EntityBase";

const COUPON_SEED_FIELDS = {
    couponId: { defaultValue: '' }
}

// 게임은 쿠폰 코드를 대문자로만 조회하므로 업로드 시 대문자로 맞춘다. (서버에서도 동일하게 정규화)
export class CouponSeedEntity extends EntityBase {
    constructor(data = {}) {
        super(data, COUPON_SEED_FIELDS);
        this.couponId = String(this.couponId).trim().toUpperCase();

        this.errors = [
            { condition: () => !/^[A-Z0-9]{1,20}$/.test(this.couponId), message: '쿠폰 코드는 영문/숫자 20자 이내여야 합니다.' },
        ]
    }

    getIdentityKey() {
        return 'couponId';
    }
}
